import React, { useState, useEffect } from 'react';
import Listingheader from 'routes/home/components/common/ListingheaderV2';
import AtfContent from 'components_library/molecules/AtfContent/AtfContent';
import LoaderSpinner from 'components_v2/common/LoaderSpinner/LoaderSpinner';
import { createSlug } from 'utils/common';
import makeRequest from 'utils/makeRequest';
import Morebtn from 'components_v2/desktop/Morebtn';
import LinksList from 'components_v2/desktop/LinksList/LinksList';
import LinksListMobile from 'components_v2/mobile/LinksList';
import s from '../WeatherReportsWrap/WeatherReportsWrap.scss';
import InputSearch from '../InputSearch';
import { IMAGE_URL, TOI_LIVE_DOMAIN } from '../../../constants';
import SortSelect from '../SortSelect/index';
import WeatherDayForecast from '../WeatherDayForecast/WeatherDayForecast';
import WeatherAqiReports from '../WeatherAqiReports/WeatherAqiReports';
import analyticsWrapper from '../../../helpers/analytics/analyticsWrapper';
import WeatherHourlyForecast from '../WeatherHourlyForecast/WeatherHourlyForecast';

const WeatherPageWrapper = ({ sectionItem, isMobile }) => {
  const defaultImage = `${IMAGE_URL}114014329.cms`;
  const [dropDown, setDropdown] = useState([]);
  const [geocity, setGeocity] = useState({});
  const [currentState, setCurrentState] = useState({});
  const [currentCity, setCurrentCity] = useState({});
  const [weatherCurrentState, setWeatherCurrentState] = useState({});
  const [weatherCurrentCity, setWeatherCurrentCity] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [sectionData, setSectionData] = useState({});
  const {
    promoData,
    name,
    subheading,
    desc,
    aqiDesc,
    stateList,
    aqiHeading,
    pageDataUrl,
    geoDataUrl,
  } = sectionItem;
  const fetchData = async searchQuery => {
    try {
      const response = await makeRequest.get(
        `${TOI_LIVE_DOMAIN}/forecast_location_ext.cms?query=${encodeURIComponent(
          searchQuery,
        )}`,
        'skipfeedengine',
      );
      let data = await response.data?.location;
      if (
        data?.address &&
        Array.isArray(data.address) &&
        data.address.length > 0
      ) {
        data = data.address.map((item, index) => ({
          name: item,
          link: `${TOI_LIVE_DOMAIN}/weather/${createSlug(
            item.split(',')[0],
          )}-weather-forecast-today/${data.postalCode[index]}`,
        }));
      }
      const address =
        data && Array.isArray(data) && data.length > 0
          ? data.filter(addr => addr.name.toLowerCase().includes(', india'))
          : [];
      setDropdown(address);
    } catch (error) {
      setDropdown([]);
    }
  };

  const fetchWidgetData = async city => {
    setIsLoading(true);
    await makeRequest
      .get(`${pageDataUrl}/${createSlug(city)}-widget-data`)
      .then(response => {
        if (response && response.data && response.data.sectionItems) {
          setSectionData(response.data.sectionItems);
        }
        setIsLoading(false);
      })
      .catch(error => {
        setIsLoading(false);
        fetchWidgetData('new-delhi');
      });
  };

  useEffect(() => {
    makeRequest.get(geoDataUrl).then(res => {
      const { data } = res;
      if (data && data.city && createSlug(data.city) === 'delhi') {
        data.city = 'new-delhi';
      }
      setGeocity(data.city || 'new-delhi');
      fetchWidgetData(data.city || 'new-delhi');
    });
  }, []);

  const { currentData, aqiRangeData, hourlyData, geoCityData } = sectionData;

  const searchHandler = e => {
    const delayDebounceFn = setTimeout(() => {
      if (e.target.value) {
        fetchData(e.target.value);
      } else {
        setDropdown([]);
      }
    }, 1000);
    return () => clearTimeout(delayDebounceFn);
  };

  const handleWeatherCityChange = item => {
    const formattedText = item?.name.replace(/\s+/g, '-');
    const cityName = formattedText.toLowerCase();
    const nextDataUrl = `/weather/${cityName}-weather-forecast-today/${
      item?.value
    }`;

    window.history.pushState({}, '', nextDataUrl);
    window.location.reload();
  };

  const handleCityChange = item => {
    const nextDataUrl = `/weather/${createSlug(
      item?.name,
    )}-aqi-level-air-quality-index-today/${item?.value}`;

    setCurrentCity({
      name: item.name,
      seoname: '',
      aqiUrl: nextDataUrl,
    });
  };

  const handleWeatherStateChange = item => {
    const cities = item.cities.map(obj => ({
      name: obj.cityName,
      value: obj.cityId,
    }));

    setWeatherCurrentCity({ name: '' });

    setWeatherCurrentState({
      name: item?.name,
      cityList: cities,
    });
  };

  const handleStateChange = item => {
    const cities = item.cities.map(obj => ({
      name: obj.cityName,
      value: obj.cityId,
    }));

    setCurrentCity({ name: '' });

    setCurrentState({
      name: item?.name,
      cityList: cities,
    });
  };

  return (
    <div className={s.wearherPageWrap}>
      {!isMobile &&
        promoData &&
        Array.isArray(promoData) &&
        promoData.length > 0 && (
          <LinksList
            sectionData={{ items: promoData, name: 'AQI Trendings' }}
            key="keywords"
            gaCategory="top_tabs_click"
            label="weather_aqi_landing"
            weatherMainPage
          />
        )}

      {isMobile &&
        promoData &&
        Array.isArray(promoData) &&
        promoData.length > 0 && (
          <div className="light_capsul">
            <LinksListMobile
              sectionData={{ data: promoData, name: 'AQI Trendings' }}
              isWapView
              cssSelector="link_list_light"
              heading="AQI Trendings"
            />
          </div>
        )}

      <div className={`${s.headingRow}`}>
        <Listingheader
          headingType="h1"
          headingname={name}
          subheading={`Date: ${subheading}`}
        />
        {/* <div className={s.searchWrap}>
          <InputSearch
            placeholder="Search Cities"
            searchHandler={searchHandler}
            dropDown={dropDown}
            // cityId={cityId}
            ga4Type="select_city_click"
            ga4Category="weather_search"
            ga4Label="weather_aqi_landing"
          />
        </div> */}
      </div>
      <div className={`${s.heading_dd}`}>
        <div className={s.dd_blk}>
          {stateList &&
            Array.isArray(stateList) &&
            stateList.length > 0 && (
              <SortSelect
                label="Select State"
                options={stateList}
                onSelect={handleWeatherStateChange}
                selectedOption={weatherCurrentState}
                searchOperation
                handleToggleIcon
                isMobile={isMobile}
                Url
              />
            )}
          {stateList &&
            Array.isArray(stateList) &&
            stateList.length > 0 && (
              <SortSelect
                label="Select City"
                options={weatherCurrentState?.cityList}
                onSelect={handleWeatherCityChange}
                selectedOption={weatherCurrentCity}
                searchOperation
                handleToggleIcon
                isMobile={isMobile}
                Url
              />
            )}
        </div>
      </div>
      {desc && <AtfContent content={desc} />}

      <div
        className={`${s.weatherMainWrap} ${currentData?.temperature?.class}`}
        style={{
          backgroundImage: `url(${currentData?.temperature?.theme ||
            defaultImage})`,
        }}
      >
        {isLoading && <LoaderSpinner />}
        <div className={s.col1}>
          <WeatherDayForecast
            dayForecast={currentData}
            ga4Data={[
              {
                event: 'user_click',
                type: `${createSlug(geoCityData?.aqi_city)}_click`,
                category: 'title_city_click',
                label: 'weather_aqi_landing',
              },
            ]}
            link={`/weather/${createSlug(
              geoCityData?.weather_city_name,
            )}-weather-forecast-today/${geoCityData?.postal}`}
            cityName={
              geoCityData &&
              geoCityData?.aqi_city &&
              geoCityData?.state_name &&
              `${geoCityData?.aqi_city}, ${geoCityData?.state_name}`
            }
          />
        </div>
        <div className={s.col2}>
          <WeatherAqiReports
            {...aqiRangeData}
            cityId={currentCity?.value}
            cityName={currentCity?.name}
          />
          <WeatherHourlyForecast
            hourlyData={hourlyData}
            weatherForcastPageUrl={geoCityData?.weather_url}
            cityName={geoCityData?.aqi_city}
          />
        </div>
      </div>

      <Listingheader
        headingType="h1"
        headingname={aqiHeading}
        subheading={`Date: ${subheading}`}
      />

      {aqiDesc && <AtfContent content={aqiDesc} />}
      <div className={s.common_blk}>
        <div className={`${s.heading_dd}`}>
          <div className={s.dd_blk}>
            {stateList &&
              Array.isArray(stateList) &&
              stateList.length > 0 && (
                <SortSelect
                  label="Select State"
                  options={stateList}
                  onSelect={handleStateChange}
                  selectedOption={currentState}
                  searchOperation
                  handleToggleIcon
                  isMobile={isMobile}
                  Url
                  ga4Data={{
                    event: 'user_click',
                    type: 'select_state_click',
                    category: 'aqi_state_search_click',
                    label: 'weather_aqi_landing',
                  }}
                />
              )}
            {stateList &&
              Array.isArray(stateList) &&
              stateList.length > 0 && (
                <SortSelect
                  label="Select City"
                  options={currentState?.cityList}
                  onSelect={handleCityChange}
                  selectedOption={currentCity}
                  searchOperation
                  handleToggleIcon
                  isMobile={isMobile}
                  Url
                  ga4Data={{
                    event: 'user_click',
                    type: 'select_city_click',
                    category: 'aqi_city_search_click',
                    label: 'weather_aqi_landing',
                  }}
                />
              )}
          </div>
        </div>
        <div className={s.action_btn}>
          <Morebtn
            moreLink={currentCity?.aqiUrl}
            moreText="Check AQI"
            redBrdr
            disabled={!currentCity?.aqiUrl}
            fullWidth
            ga4Data={[
              {
                event: 'user_click',
                type: 'check_aqi_click',
                category: 'check_aqi_submit_click',
                label: 'weather_aqi_landing',
              },
            ]}
          />
        </div>
      </div>
    </div>
  );
};

export default WeatherPageWrapper;
